import React from "react";
import Layout from "@/components/Layout";
import usePageMeta from "@/hooks/use-page-meta";
import * as Icons from "lucide-react";
import { Button } from "@/components/ui/button";
import { EQUIPMENT } from "@/constants/content";
import { useBooking } from "@/contexts/BookingContext";
import { Phone, MessageCircle, ArrowRight } from "lucide-react";
import { PHONES, WHATSAPP_URL } from "@/constants/content";

export default function MedicalEquipmentPage() {
  const { open } = useBooking();
  usePageMeta("Medical Equipment Rental in Delhi NCR — KinFlex", "Rent ICU beds, ventilators, oxygen concentrators, BiPAP, wheelchairs and more across Delhi NCR. Delivery, installation, pickup included.");
  return (
    <Layout>
      <section className="pt-32 pb-12 md:pt-40 md:pb-16 bg-hero-gradient relative overflow-hidden">
        <div className="absolute inset-0 bg-medical-grid opacity-60 pointer-events-none" />
        <div className="container-page relative max-w-4xl">
          <div className="eyebrow mb-4">Medical Equipment</div>
          <h1 className="font-display font-bold text-slate-900 text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
            ICU-grade equipment, <span className="bg-gradient-to-r from-[#0A84FF] to-[#10B981] bg-clip-text text-transparent">on rent, at home</span>.
          </h1>
          <p className="mt-6 text-lg text-slate-600 max-w-2xl">
            From ICU beds and ventilators to oxygen concentrators and wheelchairs — everything you need to convert your home into a care unit. Delivery, installation, and pickup included.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Button onClick={() => open("Medical Equipment Rental")} className="rounded-full bg-[#0A84FF] hover:bg-[#0070d9] text-white px-7 h-12 font-semibold shadow-lg shadow-[#0A84FF]/25">
              Request Equipment <ArrowRight className="h-4 w-4 ml-1.5" />
            </Button>
            <a href={`tel:${PHONES[0]}`} className="inline-flex items-center gap-2 rounded-full bg-white border border-slate-200 text-slate-900 px-6 h-12 font-semibold">
              <Phone className="h-4 w-4" style={{ color: '#EF4444' }} /> Call {PHONES[0]}
            </a>
            <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full bg-[#25D366] text-white px-6 h-12 font-semibold">
              <MessageCircle className="h-4 w-4" /> WhatsApp
            </a>
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16 bg-white">
        <div className="container-page grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {EQUIPMENT.map((e, i) => {
            const Icon = Icons[e.icon] || Icons.Boxes;
            return (
              <div key={e.name} className="rounded-2xl border border-slate-200/70 bg-white p-5 hover:border-[#0A84FF]/30 hover:shadow-md transition-all" data-testid={`equipment-page-${i}`}>
                <div className="flex items-start gap-3">
                  <div className="h-11 w-11 rounded-xl flex items-center justify-center shrink-0" style={{ background: 'rgba(10, 132, 255, 0.1)' }}>
                    <Icon className="h-5 w-5" style={{ color: '#0A84FF' }} />
                  </div>
                  <div>
                    <div className="font-display font-semibold text-slate-900">{e.name}</div>
                    <div className="text-sm text-slate-600 mt-1 leading-relaxed">{e.desc}</div>
                  </div>
                </div>
                <button onClick={() => open("Medical Equipment Rental")} className="mt-4 text-xs font-semibold text-[#0A84FF] hover:underline">
                  Enquire for rental →
                </button>
              </div>
            );
          })}
        </div>
      </section>
    </Layout>
  );
}
